export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13956.71f4511a.jpg";